import { useKcToken } from "../../setup/auth/useKcToken";
import { decodeJwt } from "../../setup/util/decodeToken";
import { logOut } from "../../setup/context/authContext";
import { DarkLogo } from "../common/logo";
import OutlinedButton, {
  OutlinedButtonSize,
} from "../common/OutlinedButton";
import styles from "./styles.module.scss";

interface TokenClaims {
  given_name?: string;
  family_name?: string;
  email?: string;
}

/**
 * Shown above the org-gate screens (create/pending/rejected) — these render instead of the
 * Sidebar (which normally carries the user's name + logout), so without this the user would have
 * no way to see who they're signed in as or sign out until their org is verified.
 */
const OrganizationGateHeader: React.FC = () => {
  const token = useKcToken();
  const claims = decodeJwt<TokenClaims>(token);
  const displayName =
    [claims?.given_name, claims?.family_name].filter(Boolean).join(" ") ||
    claims?.email ||
    "";

  return (
    <div className={styles.gateHeader}>
      <DarkLogo sx={{ height: "32px" }} />
      <div className={styles.gateHeaderUser}>
        {displayName && (
          <span className={styles.gateWelcome}>{`مرحبًا، ${displayName}`}</span>
        )}
        <div className={styles.gateLogoutWrapper}>
          <OutlinedButton size={OutlinedButtonSize.SMALL} onClick={() => logOut()}>
            تسجيل خروج
          </OutlinedButton>
        </div>
      </div>
    </div>
  );
};

export default OrganizationGateHeader;
